export const disableSection = [
  '',
  `mutation disableSection($id:Int!) {
      disableSection(id:$id)
    }
  `,
  'disableSection'];
